require('./policyAddEditDialog.style.scss');
const Policy = require('../../../../model/Policy');

class PolicyAddEditDialogController {
    constructor($scope, $filter, $timeout, policiesPersistence, notificationService, policiesUtils, validationsService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.policiesUtils = policiesUtils;
        this.validationsService = validationsService;
        this.$filter = $filter;
        this.persistence = policiesPersistence;
        this.notificationService = notificationService;
        this.targetList = [];
        this.copy = {};
        this.numberPattern = this.validationsService.getNumberPattern();
        this.tagNamePattern = this.validationsService.getTagNamePattern();
        this.isSnapOnly = false;

        this.$scope.$watch(() => this.intervalTime, intervalTime => {
            if (!this.intervalTime || !this.policy) return;
            if (this.policiesUtils.writeRtoRpo(this.policy.intervalInMinutes, intervalTime.value) !== this.intervalValue) {
                this.policy.intervalInMinutes = this.policiesUtils.writeRtoRpo(this.intervalValue, intervalTime.value);
            }
            this.maxInterval = this.policiesUtils.setRpoRtoValidation(this.intervalTime, true);
            this.checkIfSnapOnly();
            this.minInterval = this.policiesUtils.setMinRpoRtoValidation(this.intervalTime, this.isSnapOnly);
            this.minRetentionInterval = this.policiesUtils.setRetMinValidation(this.retentionInterval, this.policiesUtils.writeRtoRpo(this.intervalValue, this.intervalTime.value));
        });

        this.$scope.$watch(() => this.intervalValue, () => {
            if (this.dialogForm && this.dialogForm.inputintervalValue) {
                this.intervalValue = this.dialogForm.inputintervalValue.$$rawModelValue;
            }

            if (this.intervalValue > this.maxInterval) {
                this.intervalValue = this.maxInterval;
            }

            this.handleIntervalValueChange();
        });

        this.$scope.$watch(() => this.retentionInterval, retentionInterval => {
            if (!this.retentionInterval || !this.policy) return;
            if (this.policiesUtils.writeRetention(this.policy.backupRetention, retentionInterval.value) !== this.retentionValue) {
                this.policy.backupRetention = this.policiesUtils.writeRetention(this.retentionValue, retentionInterval.value);
            }
            this.maxRetentionInterval = this.policiesUtils.setRetValidation(this.retentionInterval);
            this.minRetentionInterval = this.policiesUtils.setRetMinValidation(this.retentionInterval, this.policiesUtils.writeRtoRpo(this.intervalValue, this.intervalTime.value));
        });

        this.$scope.$watch(() => this.retentionValue, (retentionValue) => {
            this.handleRetentionValueChange();
            this.handleCopyRetentionValueChange();
        });

        this.$scope.$watch(() => this.copy.retentionValue, (retentionValue) => {
            this.handleRetentionValueChange();
            this.handleCopyRetentionValueChange();
        });

        this.$scope.$watch(() => this.backupTargetType, (backupTargetType) => {
            if (backupTargetType) {
                this.policy.backupTargetType = backupTargetType;
                if (backupTargetType === 'SNAPSHOT') {
                    this.policy.backupTarget = null;
                    this.target = this.defaultSnapshot;
                    this.handleIntervalValueChange();
                } else {
                    this.setUpTarget();
                    if (this.policy.backupTarget === null) {
                        this.policy.backupTarget = this.target ? this.target.value : null;
                    }
                    this.handleIntervalValueChange();

                }
            }
        });

        this.$scope.$watchCollection(() => this.copy, copy => {
            if (!_.isEmpty(copy)) {
                this.policy.copyTarget = copy.target && (copy.target.value || copy.target.isDefault) ? copy.target.value : null;
                this.handleCopyRetentionValueChange();
            }
        });

        this.$scope.$watchCollection(() => this.target, target => {
            if (!_.isEmpty(target) && this.backupTargetType === 'TARGET') {
                this.handleIntervalValueChange();
                this.handleCopyRetentionValueChange();
            } else {
                this.handleIntervalValueChange();
            }
        });

        this.$scope.$watch(() => this.archive, archive => {
            if (archive) {
                this.policy.archive = archive.value;
            }
        });

        this.$scope.$watch(() => this.backupWindow, backupWindow => {
            if (backupWindow) {
                this.policy.backupWindow = backupWindow.value;
            }
        });

        this.$scope.$watch(() => this.enabledOptions, (enabledOptions, oldValue) => {
            if (!enabledOptions || !this.policy) return;
            if (enabledOptions.indexOf('copy') < 0) {
                this.policy.copyTarget = null;
                this.policy.copyRetention = null;
                this.copy.target = null;
                this.copy.retentionValue = null;
                this.handleIntervalValueChange();

            }
            else {
                this.backupTargetType = this.target.isSnapshot ? 'SNAPSHOT' : 'TARGET';
                this.copy.target = (this.target && (this.target.value === null && !this.target.isSnapshot)) ? this.defaultCopyTarget : this.copy.target ? this.copy.target : this.defaultCopyTarget;
                this.target = (this.backupTargetType === 'SNAPSHOT') ? this.defaultSnapshot : this.target ? this.target : this.defaultSnapshot;

                this.copy.retentionValue = this.copy.retentionValue || this.retentionValue;
                this.copy.retentionInterval = this.copy.retentionInterval || this.retentionInterval;
                this.handleIntervalValueChange();

            }
            if (enabledOptions.indexOf('backupWindow') < 0) {
                this.policy.backupWindow = null;
                this.backupWindow = null;
            }
            if (enabledOptions.indexOf('archiving') < 0) {
                this.policy.archive = null;
                this.archive = null;
            }
            if (enabledOptions.indexOf('tags') < 0) {
                this.policy.tags = [];
                this.tags = [];
            }
        });
    }

    $onInit() {
        this.targetSearch = {};
        this.copyTargetSearch = {};

        this.actionButtons = [
            {
                title: this.$filter('translate')('common.form.default.btn.save.label'),
                type: 'submit',
                action: this.savePolicy.bind(this),
                isDisabled: () => this.dialogForm && !this.dialogForm.$valid,
                id: 'policies-add-edit-save'
            }
        ];
        this.intervals = [
            { id: 1, label: this.$filter('translate')('policy.dialog.time.option.months.label'), value: 'MONTHS' },
            { id: 2, label: this.$filter('translate')('policy.dialog.time.option.weeks.label'), value: 'WEEKS' },
            { id: 3, label: this.$filter('translate')('policy.dialog.time.option.days.label'), value: 'DAYS' },
            { id: 4, label: this.$filter('translate')('policy.dialog.time.option.hours.label'), value: 'HOURS' },
            { id: 5, label: this.$filter('translate')('policy.dialog.time.option.minutes.label'), value: 'MINUTES' }
        ];
        this.retentionIntervals = [
            { id: 1, label: this.$filter('translate')('policy.dialog.time.option.months.label'), value: 'MONTHS' },
            { id: 2, label: this.$filter('translate')('policy.dialog.time.option.weeks.label'), value: 'WEEKS' },
            { id: 3, label: this.$filter('translate')('policy.dialog.time.option.days.label'), value: 'DAYS' }
        ];
        // this.snapshotLocations = [
        //     { name: this.$filter('translate')('policy.dialog.snapshotLocation.regional'), value: 'REGIONAL' },
        //     { name: this.$filter('translate')('policy.dialog.snapshotLocation.multiregional'), value: 'MULTI_REGIONAL' }
        // ];
        this.backupTargetTypes = [
            { name: this.$filter('translate')('policy.dialog.backupTargetType.target'), value: 'TARGET' },
            { name: this.$filter('translate')('policy.dialog.backupTargetType.snapshot'), value: 'SNAPSHOT' }
        ];

    }

    setDefaults() {
        this.intervalTime = this.intervals[4];
        this.retentionInterval = this.retentionIntervals[1];
        this.copy.retentionInterval = this.retentionIntervals[1];
        // this.snapshotLocation = this.snapshotLocations[0].value;
        this.backupTargetType = this.backupTargetTypes[1].value;
        this.intervalValue = 0;
        this.retentionValue = 4;
        this.targetList = [];
        this.backupWindowOptions = [];
        this.targetOptions = [];
        this.rpo = '';
        this.tags = [];
        this.availableOptions = [
            {
                id: 'backup-tag',
                label: this.$filter('translate')('policy.edit.form.backup.segment.label'),
                color: 'policy-backup-status',
                value: 'backup',
                isDefault: true,
                selected: true
            },
            {
                id: 'backup-window-tag',
                label: this.$filter('translate')('policy.edit.form.backupWindow.segment.label'),
                color: 'policy-backup-window-status',
                value: 'backupWindow',
                selected: this.policy && this.policy.backupWindow
            },
            {
                id: 'copy-tag',
                label: this.$filter('translate')('policy.edit.form.copy.label'),
                color: 'policy-copy-status',
                value: 'copy',
                selected: this.policy && this.policy.copyRetention
            },
            {
                id: 'archiving-tag',
                label: this.$filter('translate')('policy.edit.form.archiving.label'),
                color: 'policy-archiving-status',
                value: 'archiving',
                selected: this.policy && this.policy.archive
            }
            ,
            {
                id: 'tags-tag',
                label: this.$filter('translate')('policy.edit.form.tags'),
                color: 'policy-tags-status',
                value: 'tags',
                selected: this.policy && this.policy.tags.length > 1
            }
        ];

        this.defaultSnapshot = {
            id: 'default-snap',
            label: this.$filter('translate')('policy.dialog.backupTargetType.snapshot'),
            value: null,
            isOriginal: true,
            isDefault: true,
            isSelected: true,
            isSnapshot: true
        };

        this.defaultTarget = {
            id: 'default',
            label: this.$filter('translate')('policy.edit.form.target.auto'),
            value: null,
            isOriginal: true,
            isDefault: false,
            isSelected: false
        };

        this.defaultCopyTarget = {
            id: 'default',
            label: this.$filter('translate')('policy.edit.form.target.auto'),
            value: null,
            isOriginal: true,
            isDefault: true,
            isSelected: false
        };
    }

    onOpen() {
        this.closeId = { close: 'policies-add-edit-close', closeIcon: 'policies-add-edit-close-icon' };
        this.setDefaults();
        this.busy = true;
        if (this.policy && this.isEditMode) {
            this.helpId = 'policy-edit';
            this.modalTitle = this.$filter('translate')('policy.edit.title');
            this.busy = this.persistence.getPolicy(this.policy.uuid).then(resp => {
                this.policy = Policy.fromRaw(resp.data.entities[0]);
                this.currentPolicyName = this.policy.name;
                this.backupTargetType = this.policy.backupTargetType;
                // this.snapshotLocation = this.policy.snapshotLocation;
                this.setUpTarget();
                if (this.policy.tags) {
                    this.tags = this.policy.tags;
                    this.tags.shift();
                }
                this.setUpTargets();
                this.setUpBackupWindow();
                this.setUpArchiving();
                this.tmpOptions = this.enabledOptions;
            });
        } else {
            this.helpId = 'policy-create';
            this.modalTitle = this.$filter('translate')('policy.new.title');
            this.policy = new Policy();
            this.policy.copyRetention = 40320;
            this.policy.backupRetention = 40320;
            // this.policy.snapshotLocation = this.snapshotLocation;
            this.policy.backupTargetType = this.backupTargetType;
            this.setUpTarget();
            this.setUpTargets();
            this.setUpBackupWindow();
            this.setUpArchiving();
        }

        [this.intervalValue, this.intervalTime] = this.prepare(this.policy.intervalInMinutes, this.intervalTime);
        [this.retentionValue, this.retentionInterval] = this.prepareRetention(this.policy.backupRetention, this.retentionInterval);
        if (this.policy.copyRetention) {
            [this.copy.retentionValue, this.copy.retentionInterval] = this.prepareRetention(this.policy.copyRetention, this.copy.retentionInterval);
        }
        this.$timeout(() => {
            this.rpo = this.policy.rpo;
        }, 0);
    }

    setUpTargets() {
        this.persistence.getTargets().then(targets => {
            this.targetList = targets.map((b, i) => ({
                id: i,
                label: b.label,
                value: b.value
            }));
            for (let i = 0; i < this.targetList.length; i++) {
                if (this.targetList[i].value === this.policy.copyTarget) {
                    this.copy.target = this.targetList[i];
                    break;
                } else {
                    this.copy.target = this.defaultCopyTarget;
                    this.copy.target.isSelected = true;
                }
            }
            this.allCopyTargets = this.targetList;
        }).finally(() => {
            this.busy = false;
        });
    }

    setUpTarget() {
        this.persistence.getTargets().then(target => {
            this.targetOptions = target.map((b, i) => ({
                group: 'Target',
                id: i,
                label: b.label,
                value: b.value
            }));
            this.targetOptions.unshift(this.defaultTarget);

            if (this.backupTargetType === 'SNAPSHOT') {
                this.target = this.defaultSnapshot;
            } else {
                for (let i = 0; i < this.targetOptions.length; i++) {
                    if (this.targetOptions[i].value === this.policy.backupTarget) {
                        this.target = this.targetOptions[i];
                        break;
                    } else {
                        this.target = this.defaultTarget;
                        this.target.isSelected = true;
                    }
                }
            }

            this.allTargets = this.targetOptions;
        }).finally(() => {
            this.busy = false;
        });
    }

    setUpBackupWindow() {
        this.persistence.getBackupWindowsDropdown().then(backupWindow => {
            this.backupWindowOptions = backupWindow.map((b, i) => ({
                id: i,
                label: b.label,
                value: b.value
            }));
            for (let i = 0; i < this.backupWindowOptions.length; i++) {
                if (this.backupWindowOptions[i].value === this.policy.backupWindow) {
                    this.backupWindow = this.backupWindowOptions[i];
                }
            }

            this.allBackupWindows = this.backupWindowOptions;
        }).finally(() => {
            this.busy = false;
        });
    }

    setUpArchiving() {
        this.persistence.getArchivesDropdown().then(archive => {
            this.archiveOptions = archive.map((b, i) => ({
                id: i,
                label: b.label,
                value: b.value
            }));
            for (let i = 0; i < this.archiveOptions.length; i++) {
                if (this.archiveOptions[i].value === this.policy.archive) {
                    this.archive = this.archiveOptions[i];
                }
            }

            this.allArchives = this.archiveOptions;
        }).finally(() => {
            this.busy = false;
        });
    }

    onCloseModal(isSave) {
        this.showModal = false;
        this.currentPolicyName = null;

        if (isSave) {
            this.onClose({ policy: this.policy });
        } else {
            this.onClose();
        }
    }

    resetValuesOnClose() {
        this.enabledOptions = this.isEditMode ? this.tmpOptions : [];
        this.tagEntry = '';
        this.tagValue = '';
    }


    savePolicy() {
        this.policy.backupTarget = this.target && this.target.value ? this.target.value : null;
        this.policy.backupTargetType = this.target.isSnapshot ? 'SNAPSHOT' : 'TARGET';
        if (this.copy) {
            this.policy.copyTarget = this.copy.target && this.copy.target.value ? this.copy.target.value : null;

        }
        this.policy.tags = this.tags;
        this.busy = this.persistence[this.policy.uuid ? 'updatePolicy' : 'createPolicy'](this.policy, this.currentPolicyName).then(resp => {
            this.policy.uuid ? this.onCloseModal(false) : this.onCloseModal(true);
            this.notificationService.pop(resp.data.message);
        });
    }

    prepare(item, timeItem) {
        if (item <= 0) return;
        timeItem = this.intervals.filter(o => o.value === this.policiesUtils.calculateRtoRpoTime(item))[0];
        item = this.policiesUtils.readRtoRpo(item, timeItem.value);
        return [item, timeItem];
    }

    prepareRetention(item, timeItem) {
        if (item <= 0) return;
        timeItem = this.retentionIntervals.filter(o => o.value === this.policiesUtils.calculateRetentionTime(item))[0];
        item = this.policiesUtils.readRetention(item, timeItem.value);
        return [item, timeItem];
    }

    isVisible(value) {
        return this.enabledOptions && this.enabledOptions.indexOf(value) >= 0;
    }

    handleIntervalValueChange() {
        if (!this.intervalValue || !this.policy) return;
        let cronValue = this.policiesUtils.writeRtoRpo(this.intervalValue, this.intervalTime.value);
        if (this.policy.intervalInMinutes !== cronValue) this.policy.intervalInMinutes = cronValue;
        if (this.intervalTime) {
            this.maxInterval = this.policiesUtils.setRpoRtoValidation(this.intervalTime, true);
            this.checkIfSnapOnly();
            this.minInterval = this.policiesUtils.setMinRpoRtoValidation(this.intervalTime, this.isSnapOnly);
            this.minRetentionInterval = this.policiesUtils.setRetMinValidation(this.retentionInterval, this.policiesUtils.writeRtoRpo(this.intervalValue, this.intervalTime.value));
            if (this.copy.retentionValue) {
                this.minCopyRetentionInterval = this.policiesUtils.setCopyRetMinValidation(this.copy.retentionInterval, this.policy.backupRetention);
            }
        }
    }

    handleRetentionValueChange() {
        if (!this.retentionValue || !this.policy) return;
        let cronValue = this.policiesUtils.writeRetention(this.retentionValue, this.retentionInterval.value);
        if (this.policy.backupRetention !== cronValue) this.policy.backupRetention = cronValue;
        if (this.retentionValue) {
            this.maxRetentionInterval = this.policiesUtils.setRetValidation(this.retentionInterval);
            this.minRetentionInterval = this.policiesUtils.setRetMinValidation(this.retentionInterval, this.policiesUtils.writeRtoRpo(this.intervalValue, this.intervalTime.value));
            if (this.copy.retentionValue) {
                this.minCopyRetentionInterval = this.policiesUtils.setCopyRetMinValidation(this.copy.retentionInterval, this.policy.backupRetention);
            }
        }
    }

    handleCopyRetentionValueChange() {
        if (!this.copy || !this.policy) return;
        let cronValue = this.policiesUtils.writeRetention(this.copy.retentionValue, this.copy.retentionInterval.value);
        if (this.policy.copyRetention !== cronValue && cronValue !== 0) this.policy.copyRetention = cronValue;
        this.maxCopyRetentionInterval = this.policiesUtils.setRetValidation(this.copy.retentionInterval);
        this.minCopyRetentionInterval = this.policiesUtils.setCopyRetMinValidation(this.copy.retentionInterval, this.policy.backupRetention);
    }

    handleRPOChange(value) {
        if (value) this.policy.rpo = value;
    }

    addTagEntry(name, value, event) {
        event.preventDefault();
        if (this.tags.filter(element => element.name.toUpperCase() === name.toUpperCase()).length === 0) {
            this.tags.push({ name: name, value: value });
        } else {
            this.isTagError = true;
            this.$timeout(() => {
                this.isTagError = false;
            }, 2000);
        }
        this.tagEntry = '';
        this.tagValue = '';
        this.tagForm.tagValue.$setUntouched();
        this.tagForm.tagValue.$setPristine();
        this.tagForm.tagEntry.$setUntouched();
        this.tagForm.tagEntry.$setPristine();
    }

    removeTagEntry(item) {
        this.tags = this.tags.filter(element => element.name !== item.name);
    }

    disableAddButton() {
        return !this.tagEntry || !this.tagValue || (this.tagEntry && this.tagEntry.toLowerCase() === 'hycu-policy');
    }

    checkIfSnapOnly() {
        if (this.enabledOptions) {
            if (this.target.isSnapshot && this.enabledOptions.indexOf('copy') < 0) {
                this.isSnapOnly = true;
            } else {
                this.isSnapOnly = false;
            }
        }
    }

    searchTargets() {
        this.targetOptions = this.allTargets.filter(target => target.label.toLowerCase().indexOf(this.targetSearch.searchBy.toLowerCase()) !== -1);
    }

    searchCopyTargets() {
        this.targetList = this.allCopyTargets.filter(target => target.label.toLowerCase().indexOf(this.copyTargetSearch.searchBy.toLowerCase()) !== -1);
    }

    searchBackupWindows() {
        this.backupWindowOptions = this.allBackupWindows.filter(bw => bw.label.toLowerCase().indexOf(this.bwSearch.searchBy.toLowerCase()) !== -1);
    }

    searchArchives() {
        this.archiveOptions = this.allArchives.filter(archive => archive.label.toLowerCase().indexOf(this.archiveSearch.searchBy.toLowerCase()) !== -1);
    }
}

PolicyAddEditDialogController.$inject = ['$scope', '$filter', '$timeout', 'policiesPersistence', 'notificationService', 'policiesUtils', 'validationsService'];

const policyAddEditDialogComponent = {
    controller: PolicyAddEditDialogController,
    template: require('./policyAddEditDialog.template.html'),
    bindings: {
        showModal: '=',
        policy: '<',
        onClose: '&',
        isEditMode: '<'
    }
};

module.exports = policyAddEditDialogComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/policies/dialogs/policyAddEditDialog/policyAddEditDialog.component.js